// extracted by mini-css-extract-plugin
var _1 = "message-bubble__RAsXH";
var _2 = "message-bubble__chatbot__lxTgX";
var _3 = "message-bubble__mine__xcF_A";
export { _1 as "messageBubble", _2 as "messageBubbleChatbot", _3 as "messageBubbleMine" }
